module.exports = __webpack_public_path__ + "media/notification_high-intensity.04adaac1.wav";